'use strict';

class SpendingsController {
    /* @ngInject */
    constructor(
        SpendingsService,
        $scope
    ) {
        Object.assign(this, {
            SpendingsService,
            $scope
        });

        this.query = {
            include: [
                'employee',
                'spendingType',
                'collection'
            ],
            where: {},
            limit: 10,
            page: 1,
            order: 'createdAt DESC',
            deleted: true
        };

        this.getModels();

        this.onPagination = () => {
            this.getModels();
        };

        this.onReorder = () => {
            this.getModels();
        };
    }

    afterFirstSave() {
        this.neverEditable = true;
    }

    getModels() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        if (this.voucherId) {
            Object.assign(qOpts.where, {
                voucherId: this.voucherId
            });
        }

        let queryReady = this.SpendingsService
            .getModels(qOpts)
            .then(spendings => {
                this.spendings = spendings;
            });
        let countReady = this.SpendingsService
            .getCount(qOpts)
            .then(result => {
                this.spendingsCount = result.count;
            });
        return Promise.all([queryReady, countReady]);
    }
}

export default SpendingsController;
